import { init } from 'init';

/*
The Agent would write untranslated error
messages for the Rich Results bot.
For this reason, don't load Agent if a bot is detected.
The Rich Results UA is: 
  Mozilla/5.0 (Linux; Android 6.0.1; Nexus 5X Build/MMB29P) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/116.0.5845.96 Mobile Safari/537.36 (compatible; Google-InspectionTool/1.0;)
*/
export const isBot =
    /crawler|crawling|googlebot|inspectiontool|robot|spider/i.test(
        navigator.userAgent
    );

if (!isBot) {
    try {
        init();
    } catch (e) {
        throw new Error(
            `Favs-agent: Can´t init: ${
                e instanceof Error ? e.message : String(e)
            }`
        );
    }
} else {
    console.warn('Favs-agent: Detected bot, skipping init');
}
